module.exports = __webpack_public_path__ + "static/media/Event-10.3ca7ab72.svg";